import { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { SkipNav } from '../shared/SkipNav';

interface PageShellProps {
  children: ReactNode;
  /** Hide header (not commonly used) */
  hideHeader?: boolean;
  /** Hide footer (for modal-like pages) */
  hideFooter?: boolean;
}

export function PageShell({ children, hideHeader = false, hideFooter = false }: PageShellProps) {
  return (
    <div className="min-h-screen flex flex-col bg-bg-base">
      <SkipNav />
      {!hideHeader && <Header />}
      <main id="main-content" className={`flex-1 ${hideHeader ? '' : 'pt-16'}`} tabIndex={-1}>
        {children}
      </main>
      {!hideFooter && <Footer />}
    </div>
  );
}
